import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { Menu, MenuItem, ListItemIcon, ListItemText, SvgIcon } from '@mui/material'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import LocationOffOutlinedIcon from '@mui/icons-material/LocationOffOutlined'
import { toast } from 'react-toastify'
import { useActivateDeactivateLocationsMutation } from 'api/location/activateDeactivateLocations'
import { handleError } from 'utils/error'
import { ACTIVE } from '../settings'
import { selectSelectedTab } from 'data/customer/customerDetailsLocationsSelectors'
import { setShowDeactivateAllConfirmation } from 'slices/customer/customerDetailsLocationsSlice'
import T from 'T'

const LocationsDataGridActionsMenu = ({
  anchorEl,
  onClose,
  deactivatableLocations = [],
  activatableLocations = [],
  onLocationStatusChange,
}) => {
  const selectedTab = useSelector(selectSelectedTab)
  const dispatch = useDispatch()
  const [activateDeactivateLocations] = useActivateDeactivateLocationsMutation()

  const handleActivateAllLocations = () => {
    if (activatableLocations.length === 0) return

    const payload = {
      deactivate: false,
      locations: activatableLocations.map(location => ({ id: location.id })),
    }

    activateDeactivateLocations(payload)
      .unwrap()
      .then(() => {
        if (onLocationStatusChange) {
          onLocationStatusChange()
        }
        toast.success(activatableLocations.length === 1 ? T.LOCATION_ACTIVATED_SUCCESS : T.ALL_LOCATIONS_ACTIVATED_SUCCESS)
      })
      .catch(error => {
        handleError(error)
      })
  }

  const handleDeactivateAllLocations = () => {
    dispatch(setShowDeactivateAllConfirmation(true))
  }

  const handleBulkLocationAction = () => {
    onClose()
    if (selectedTab === ACTIVE) {
      handleDeactivateAllLocations()
    } else {
      handleActivateAllLocations()
    }
  }
  return (
    <Menu
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      slotProps={{ paper: { variant: 'outlined', sx: { minWidth: 200 } } }}
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      disableScrollLock
    >
      <MenuItem
        onClick={handleBulkLocationAction}
        disabled={selectedTab === ACTIVE ? deactivatableLocations.length === 0 : activatableLocations.length === 0}
      >
        <ListItemIcon>
          {selectedTab === ACTIVE ? (
            <SvgIcon fontSize="small" color="warning">
              <LocationOffOutlinedIcon />
            </SvgIcon>
          ) : (
            <SvgIcon fontSize="small" color="success">
              <LocationOnIcon />
            </SvgIcon>
          )}
        </ListItemIcon>
        <ListItemText sx={{ color: selectedTab === ACTIVE ? 'warning.main' : 'success.main' }}>
          {selectedTab === ACTIVE ? T.DEACTIVATE_ALL_LOCATIONS : T.ACTIVATE_ALL_LOCATIONS}
        </ListItemText>
      </MenuItem>
    </Menu>
  )
}

LocationsDataGridActionsMenu.propTypes = {
  anchorEl: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  deactivatableLocations: PropTypes.array,
  activatableLocations: PropTypes.array,
  onLocationStatusChange: PropTypes.func,
}

export default LocationsDataGridActionsMenu
